export const minLengthRegexp: RegExp = /^.{12,}$/;
